import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CopyableText from "../copyable-text/copyable-text";
import { TaskModel } from "./types";

interface TaskParametersDialogProps {
  task: TaskModel | null;
  onClose: () => void;
}

const TaskParametersDialog: React.FC<TaskParametersDialogProps> = ({
  task,
  onClose,
}) => {
  if (!task?.jsonParameters) return null;

  let formattedParameters = task.jsonParameters;
  let hasValidJson = false;

  try {
    const parsed = JSON.parse(task.jsonParameters);
    formattedParameters = JSON.stringify(parsed, null, 2);
    hasValidJson = true;
  } catch {
    // Use raw parameters if JSON parsing fails
  }

  return (
    <Dialog
      open={Boolean(task)}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      slotProps={{
        paper: {
          sx: {
            borderRadius: 2,
            boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          pb: 1,
          borderBottom: "1px solid",
          borderColor: "grey.200",
          fontWeight: 600,
        }}
      >
        Task Parameters - {task?.description || "No Description"}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "grey.500",
            "&:hover": {
              backgroundColor: "grey.100",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>
        <Box
          sx={{
            fontFamily: hasValidJson ? "monospace" : "inherit",
            whiteSpace: hasValidJson ? "pre-wrap" : "normal",
            backgroundColor: "grey.50",
            p: 2,
            borderRadius: 1,
            border: "1px solid",
            borderColor: "grey.200",
            maxHeight: "400px",
            overflow: "auto",
            mt: 2,
          }}
        >
          <CopyableText text={formattedParameters} />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default TaskParametersDialog;
